import { SVGAttributes } from "react";

export function RepostIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="24" height="24" rx="12" fill="#00BA7C" fillOpacity="0.25" />
      <path
        d="M8.71053 7.80078L11.0212 10.0005L10.1648 10.9316L9.33801 10.1489V13.9192C9.33801 14.4154 9.73156 14.8144 10.2165 14.8144H12.8519V16.0934H10.2165C9.03832 16.0934 8.08305 15.1214 8.08305 13.9192V10.1489L7.25628 10.9316L6.3999 10.0005L8.71053 7.80078ZM14.4833 9.18714H11.8479V7.90821H14.4833C15.6615 7.90821 16.6168 8.8802 16.6168 10.0824V13.8527L17.4435 13.07L18.2999 14.001L15.9893 16.2008L13.6786 14.001L14.535 13.07L15.3618 13.8527V10.0824C15.3618 9.58617 14.9682 9.18714 14.4833 9.18714Z"
        fill="#00BA7C"
      />
    </svg>
  );
}
